var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"club-avatar",class:[_vm.size]},[_c('img',{staticClass:"club-avatar__img",class:{ border: _vm.isCardUser },attrs:{"src":_vm.src,"alt":""}}),(_vm.isCardUser)?_c('img',{staticClass:"club-avatar__tag",attrs:{"src":require("../../assets/image/club/avatar-tag.png"),"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }